/*
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-10-24 16:06:07
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2024-01-08 10:14:49
 * @FilePath: \jigou\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import selfMsgBox from '@/components/selfMsgBox'
// import http from '@/assets/common/http'
Vue.use(Router)


const router = new Router({
  scrollBehavior: () => ({y: 0}),
  routes: store.getters.staticRoutes
})

router.beforeEach((to, from, next) => {
  selfMsgBox.closeAll();
  let routesPathList = store.getters.routesPathList;
  
  if (routesPathList.indexOf(to.path) > -1) {
    if (to.meta.type == '2') {
      store.commit('activeMenuChange', to.meta.parentName);
    } else {
      store.commit('activeMenuChange', to.name);
    }
    next();
  } else {
    store.dispatch('getMenuList').then(() => {
      let trendsRoutes = store.getters.trendsRoutes;
      let staticRoutes = store.getters.staticRoutes;
      router.options.routes = staticRoutes.concat(trendsRoutes);
      router.matcher = new Router().matcher;
      router.addRoutes(router.options.routes);
      router.history.setupListeners();
      routesPathList = store.getters.routesPathList;
      if (routesPathList.indexOf(to.path) > -1) {
        next(to);
      } else {
        next('/login')
      }
    })
  }

})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js